import React, { useState, useEffect } from "react";
import { Button, Form, Alert, Spinner, InputGroup, Card } from "react-bootstrap";
import { fetchAmazonReviewData } from "../../http/bookAPI";
import { fetchReviewDataFromExtension } from "../../helpers/extensionScrape";
import Row from "react-bootstrap/Row";

const AmazonReviewParserExt = ({ onExtract, setCurrentStep, reviewLink, onSaved }) => {
    // поле всегда контролируем одним стейтом; проп — как начальное/входящее значение
    const [inputUrl, setInputUrl] = useState(reviewLink || "");
    const [loading, setLoading]   = useState(false);
    const [error, setError]       = useState("");

    // если проп обновился — синхронизируем поле
    useEffect(() => {
        if (typeof reviewLink === "string") {
            setInputUrl(reviewLink);
        }
    }, [reviewLink]);

    const handleSuccess = async (data) => {
        try {
            // 1) сначала отдаём данные наверх (родитель делает editAssignment)
            if (typeof onExtract === "function") {
                await onExtract(data);
                setCurrentStep("STEP5"); // имея async parent-колбэк, дождёмся обновления на сервере
            }
            // 2) затем просим родителя перечитать ассигнмент
            if (typeof onSaved === "function") {
                await onSaved(); // refetchAssignment в родителе
            }
        } catch (e) {
            // опционально: показать локальную ошибку, если onExtract упал
            console.error("onExtract/onSaved failed:", e);
        }
    };

    const fetchReviewData = async () => {
        const url = (inputUrl || "").trim();
        if (!url) {
            setError("Please enter a valid Amazon review URL.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            // 1) пробуем через расширение
            const data = await fetchReviewDataFromExtension(url, { timeoutMs: 15000 });
            handleSuccess(data);
        } catch (extErr) {
            // 2) fallback на бэкенд
            try {
                const data = await fetchAmazonReviewData(url);
                handleSuccess(data);

            } catch (e) {
                setError(
                    "Great, we got your link. We couldn’t check it automatically, but we will review it manually. Thank you. No need to send it again — we already have it."
                );
            }
        } finally {
            setLoading(false);
        }
    };



    return (
      <Row className="w-100">
            <Form onSubmit={(e) => { e.preventDefault(); fetchReviewData(); }} className="small">
                <InputGroup className="mb-0 border-success" size="sm">
                    <Form.Control
                        type="text"
                        placeholder="Paste your Amazon review link…"
                        value={inputUrl}
                        onChange={(e) => setInputUrl(e.target.value)}
                        disabled={loading}
                        size="sm"
                        className="border-success"
                    />
                    <Button
                        variant="success"
                        onClick={fetchReviewData}
                        disabled={loading}
                        type="button"
                        size="sm"
                        className="px-2"
                    >
                        {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
                    </Button>
                </InputGroup>
            </Form>


            {error && (
                <Alert variant="danger" className="mt-3">
                    {error}
                </Alert>
            )}
      </Row>
    );
};

export default AmazonReviewParserExt;
